import { Route } from '@angular/router'
import { authGuard, permissionGuard, publicGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type AuthRoutes = {
    signup: Route
    forgotPassword: Route
    newPassword: Route
    passwordResetResult: Route
    resetPassword: Route
    accountCreated: Route
    accountVerify: Route
    verifyPhone: Route
    login: Route
    organizationSelector: Route
    createProfile: Route
    statusPending: Route
    profileCreated: Route
    payment: Route
    verificationEmailSent: Route
    onboarding: Route
}

export const authRoutes: AuthRoutes = {
    signup: {
        path: 'signup',
        loadComponent: () =>
            import('@baboor/baboor-auth').then((m) => m.PageSignUpComponent),
        resolve: { layout: setLayout(PageLayout.Center) },
        canActivate: [publicGuard()],
        data: {
            title: 'Hair Style Club | Sign Up',
        },
    },
    forgotPassword: {
        path: 'forgot-password',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageForgotPasswordComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    newPassword: {
        path: 'new-password/:token',
        loadComponent: () =>
            import('../page-set-new-password/page-set-new-password.component').then(
                (m) => m.PageSetNewPasswordComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    passwordResetResult: {
        path: 'password-reset-result',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PasswordResetResultComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Cta) },
    },
    resetPassword: {
        path: 'reset-password',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageResetPasswordComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    accountCreated: {
        path: 'account-created',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageAccountCreatedComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Cta) },
    },
    accountVerify: {
        path: 'account-verify/:token',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageAccountVerifyComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Cta) },
    },
    verifyPhone: {
        path: 'verify-phone/:token',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageUserPhoneVerificationComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    login: {
        path: 'login',
        loadComponent: () =>
            import('@baboor/baboor-auth').then((m) => m.PageLoginComponent),
        resolve: { layout: setLayout(PageLayout.Center) },
        data: {
            title: 'Hair Style Club | Sign In',
        },
    },

    organizationSelector: {
        path: 'organization-selector',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('@baboor/baboor-group').then(
                (m) => m.OrganizationSelectorComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },

    // accept: {
    //     path: 'accept',
    //     loadComponent: () =>
    //         import('../page-accept-invite/page-accept-invite.component').then(
    //             (m) => m.PageAcceptInviteComponent,
    //         ),
    //     resolve: { layout: setLayout(PageLayout.Center) },
    // },

    // accept: {
    //     path: 'accept',
    //     loadComponent: () =>
    //         import('../page-accept-invite/page-accept-invite.component').then(
    //             (m) => m.PageAcceptInviteComponent,
    //         ),
    //     resolve: { layout: setLayout(PageLayout.Center) },
    // },
    createProfile: {
        path: 'create-profile',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageCreateProfileFormComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    statusPending: {
        path: 'status-pending',
        loadComponent: () =>
            import('../page-organization-status-pending/page-organization-status-pending.component').then(
                (m) => m.PageOrganizationStatusPendingComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    profileCreated: {
        path: 'profile-created',
        loadComponent: () =>
            import('@baboor/baboor-auth').then(
                (m) => m.PageProfileCreatedComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    payment: {
        path: 'payment',
        loadComponent: () =>
            import('../page-payment/page-payment.component').then(
                (c) => c.PagePaymentComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    verificationEmailSent: {
        path: 'verification-email-sent',
        loadComponent: () =>
            import('../page-verification-email-sent/page-verification-email-sent.component').then(
                (c) => c.PageVerificationEmailSentComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Center) },
    },
    onboarding: {
        path: 'onboarding',
        loadComponent: () =>
            import('../onboarding/onboarding.component').then(
                (m) => m.OnboardingComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.organization.create], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
    },
}
